import React, { useState, useEffect, useRef } from "react";
import "../css/main.scss";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { donateDeepColor, shareColor } from "../constans/ColorConstants";
import Donations from "./Donations";
import Topics from "./Topics";
import { useNavigate } from "react-router-dom";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";

const Main = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const navigate = useNavigate();

  const storedAd = LocalStorageUtil.getAd();
  const ad = storedAd || "donation";

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [Main page]:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  }, [ad]);

  const orbImages = [
    { src: "/main/main1-1.png", alt: "Education" },
    { src: "/main/main1-3.png", alt: "Your cause" },
    { src: "/main/main1-2.png", alt: "Medical" },
    { src: "/main/main1-5.png", alt: "Emergency" },
    { src: "/main/main1-6.png", alt: "Business" },
    { src: "/main/main1-4.png", alt: "Animal" },
  ];

  const [slideIndex, setSlideIndex] = useState(0);
  // internal track index for cloned items (start in middle copy)
  const [trackIndex, setTrackIndex] = useState(orbImages.length);
  const [isSnapping, setIsSnapping] = useState(false);

  // 轮播点击
  const prevSlide = () => {
    setSlideIndex((s) => (s - 1 + orbImages.length) % orbImages.length);
    setTrackIndex((t) => t - 1);
  };
  const nextSlide = () => {
    setSlideIndex((s) => (s + 1) % orbImages.length);
    setTrackIndex((t) => t + 1);
  };

  const orbGap = 28;
  const getOrbWidthFor = (visibleWidth) => {
    if (visibleWidth >= 912) return 146;
    if (visibleWidth >= 820) return 138;
    if (visibleWidth >= 768) return 140;
    return 133;
  };

  const orbsRef = useRef(null);
  const [carouselVisibleWidth, setCarouselVisibleWidth] = useState(760);
  const lastCarouselWidthRef = useRef(0);
  useEffect(() => {
    if (!orbsRef.current) return;
    let rafId = null;
    const update = () => {
      if (!orbsRef.current) return;
      const w = orbsRef.current.clientWidth || 760;
      // avoid redundant state updates
      if (lastCarouselWidthRef.current === w) return;
      lastCarouselWidthRef.current = w;
      // schedule state update on next animation frame and cancel previous if pending
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = null;
        setCarouselVisibleWidth(w);
      });
    };

    update();
  }, []);
  const orbWidth = getOrbWidthFor(carouselVisibleWidth);
  const orbStep = orbWidth + orbGap;
  const centerOffset = carouselVisibleWidth / 2 - orbWidth / 2;
  const trackTransformX = centerOffset - trackIndex * orbStep;
  const arcMultiplier = 68;
  const extraVerticalShift = 30;

  // stats auto-rotate on mobile: track which stat is visible
  const [statsIndex, setStatsIndex] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 767px)");
    let intervalId = null;
    let alive = true;
    const start = () => {
      if (intervalId) return;
      intervalId = setInterval(() => {
        if (!alive) return;
        setStatsIndex((s) => (s + 1) % 3);
      }, 3000);
    };
    const stop = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
    const handleChange = () => {
      if (mq.matches) start();
      else stop();
    };
    handleChange();
    if (mq.addEventListener) mq.addEventListener("change", handleChange);
    else mq.addListener(handleChange);
    return () => {
      stop();
      alive = false;
      if (mq.removeEventListener)
        mq.removeEventListener("change", handleChange);
      else mq.removeListener(handleChange);
    };
  }, []);

  useEffect(() => {
    if (!isSnapping) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsSnapping(false);
      });
    });
  }, [isSnapping]);

  const howImages = [
    "/main/main2-1.jpg",
    "/main/main2-2.jpg",
    "/main/main2-3.jpg",
  ];
  const [howIndex, setHowIndex] = useState(0);
  const [howProgress, setHowProgress] = useState(0);
  // play / pause control for how-section
  const [howPaused, setHowPaused] = useState(false);
  const howProgressRef = useRef(howProgress);
  useEffect(() => {
    howProgressRef.current = howProgress;
  }, [howProgress]);

  useEffect(() => {
    let rafId = null;
    const duration = 8000; // ms per image
    // start time should honor existing progress when resuming
    const startAt = () =>
      performance.now() - (howProgressRef.current / 100) * duration;
    let start = startAt();

    const tick = (now) => {
      const elapsed = now - start;
      const pct = Math.min(100, (elapsed / duration) * 100);
      setHowProgress(pct);
      if (elapsed >= duration) {
        setHowIndex((i) => (i + 1) % howImages.length);
        start = now;
        setHowProgress(0);
      }
      rafId = requestAnimationFrame(tick);
    };

    if (!howPaused) {
      // reset start based on current progress and run
      start = startAt();
      rafId = requestAnimationFrame(tick);
    }

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [howImages.length, howPaused]);

  return (
    <div
      className="main_box"
      style={{
        "--donate-deep-color": donateDeepColor,
        "--share-color": shareColor,
      }}
    >
      <Header />
      <main>
        <div>
          <section className="hero">
            <div className="hero__background hero__background--outer" />
            <div className="hero__background hero__background--inner" />

            <div className="hero__center">
              <div className="hero__kicker">#1 crowdfunding platform</div>
              <h1 className="hero__title">
                Successful
                <br />
                fundraisers
                <br />
                start here
              </h1>
              <button
                className="hero__cta"
                onClick={() => {
                  navigate("/donations");
                  toTop();
                }}
              >
                Start a HeartLink
              </button>
            </div>

            <div
              className="hero__orbs"
              aria-hidden="true"
              ref={orbsRef}
              style={{ "--orb-size": `${orbWidth}px` }}
            >
              {(() => {
                const positions = [
                  "orb--tl",
                  "orb--bl",
                  "orb--l",
                  "orb--r",
                  "orb--tr",
                  "orb--br",
                ];
                return positions.map((pos, i) => {
                  const img = orbImages[(i + slideIndex) % orbImages.length];
                  return (
                    <div className={`orb ${pos}`} key={pos}>
                      <img className="orb__ring" src="/svg/circle.svg" alt="" />
                      <img className="orb__img" src={img.src} alt={img.alt} />
                    </div>
                  );
                });
              })()}
              {/* Sliding track for tablet: visible only at tablet sizes via CSS */}
              <div
                className="hero__orbs-track"
                onTransitionEnd={() => {
                  const n = orbImages.length;
                  if (trackIndex <= n - 1) {
                    // jumped into left clone region — snap to middle copy
                    setIsSnapping(true);
                    setTrackIndex((t) => t + n);
                  } else if (trackIndex >= 2 * n) {
                    // jumped into right clone region — snap back to middle copy
                    setIsSnapping(true);
                    setTrackIndex((t) => t - n);
                  }
                }}
                style={{
                  transform: `translateX(${trackTransformX}px)`,
                  transition: isSnapping
                    ? "none"
                    : "transform 560ms cubic-bezier(.22,1.5,.36,1)",
                }}
              >
                {Array.from({ length: 3 }).flatMap((_, blockIndex) =>
                  orbImages.map((img, i) => {
                    const n = orbImages.length;
                    // visual index for this rendered item in the triple track
                    const visualIndex = blockIndex * n + i;
                    // signed distance in steps from the current visual center (trackIndex)
                    const dist = visualIndex - trackIndex;
                    // normalize distance into the range [-n, n] for shaping
                    const wrappedDist = ((dist % n) + n) % n;
                    const signedWrappedDist =
                      wrappedDist > n / 2 ? wrappedDist - n : wrappedDist;
                    const maxDist = Math.floor(n / 2);
                    const arcBase = Math.max(
                      0,
                      maxDist - Math.abs(signedWrappedDist)
                    );
                    const translateY =
                      arcBase * arcMultiplier + extraVerticalShift; // px
                    const scale = 1 + arcBase * 0.04;
                    const zIndex = 100 - Math.abs(signedWrappedDist);
                    const key = `track-${blockIndex}-${i}`;
                    return (
                      <div
                        className={`orb track-item`}
                        key={key}
                        style={{
                          transform: `translateY(${translateY}px) scale(${scale})`,
                          zIndex,
                        }}
                      >
                        <img
                          className="orb__ring"
                          src="/svg/circle.svg"
                          alt=""
                        />
                        <img className="orb__img" src={img.src} alt={img.alt} />
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* left / right arrows overlay for tablet to rotate orb images */}
            <button
              className="hero__arrow hero__arrow--left"
              onClick={prevSlide}
              aria-label="Previous orbs"
            >
              ‹
            </button>
            <button
              className="hero__arrow hero__arrow--right"
              onClick={nextSlide}
              aria-label="Next orbs"
            >
              ›
            </button>
          </section>

          <section className="hero__info">
            <div className="hero__info-left">
              <h3>More than $50 million is raised every week on HeartLink.*</h3>
            </div>
            <div className="hero__info-right">
              <p>
                Get started in just a few minutes — with helpful new tools, it's
                easier than ever to pick the perfect title, write a compelling
                story, and share it with the world.
              </p>
            </div>
          </section>
          {/* statistics strip shown below the hero (matches provided design) */}
          <section className="stats-strip" aria-hidden="true">
            <div className="stats-strip__inner">
              <ul className="stats-list">
                {[
                  {
                    id: 1,
                    icon: "/svg/thumder.svg",
                    text: "No fee to start fundraising",
                  },
                  {
                    id: 2,
                    icon: "/svg/circle.png",
                    text: "1 donation made every second",
                  },
                  {
                    id: 3,
                    icon: "/svg/bookHeart.png",
                    text: "8K+ fundraisers started daily",
                  },
                ].map((item, i, arr) => (
                  <ul key={`stat-${item.id}-${i}`}>
                    <li
                      className={`stats-item ${
                        statsIndex === i ? "is-active" : ""
                      }`}
                    >
                      <span className="stats-icon" aria-hidden="true">
                        <img alt="" src={item.icon} />
                      </span>
                      <span className="stats-text">{item.text}</span>
                    </li>
                    {i < arr.length - 1 && (
                      <li className="stats-sep" aria-hidden="true" />
                    )}
                  </ul>
                ))}
              </ul>
            </div>
          </section>

          {/* 4 */}
          <section
            className="how-section how-section--mobile"
            aria-hidden="false"
          >
            <h2 className="how-section__title">
              Fundraising on HeartLink is easy,
              <br />
              powerful, and trusted
            </h2>
            <div className="how-section__content">
              <div className="phone-mock">
                <div className="phone-mock__green">
                  <div className="phone-mock__inner">
                    <img
                      className="phone-mock__img"
                      src={howImages[howIndex]}
                      alt={`step ${howIndex + 1} preview`}
                    />
                  </div>
                  <button
                    className="how-play-toggle"
                    onClick={() => setHowPaused((p) => !p)}
                    aria-pressed={howPaused}
                    aria-label={howPaused ? "Play carousel" : "Pause carousel"}
                  >
                    {howPaused ? (
                      <svg
                        t="1766478359128"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="13357"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M161.2 839.9v-654c0-56.1 60.7-91.1 109.3-63.1l566.3 327c48.6 28 48.6 98.1 0 126.2L270.4 903c-48.5 28-109.2-7.1-109.2-63.1z"
                          fill="#ffffff"
                          p-id="13358"
                        ></path>
                      </svg>
                    ) : (
                      <svg
                        t="1766478317956"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="12226"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M209.645253 863.934444l201.049992 0 0-703.866842L209.645253 160.067602 209.645253 863.934444zM611.804588 863.934444l201.113437 0 0-703.866842L611.804588 160.067602 611.804588 863.934444z"
                          p-id="12227"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    )}
                  </button>
                  <progress
                    className="how-progress"
                    max="100"
                    value={Math.round(howProgress)}
                    aria-hidden="true"
                  />
                </div>
              </div>

              <ol className="how-steps" aria-label="How it works">
                {[
                  {
                    num: "1",
                    title: "Use our tools to create your fundraiser",
                    desc: "You’ll be guided by prompts to add fundraiser details and\n                      set your goal. Make updates anytime.",
                  },
                  {
                    num: "2",
                    title: "Reach donors by sharing",
                    desc: "Share your fundraiser link and use the resources in your\n                      dashboard to gain momentum.",
                  },
                  {
                    num: "3",
                    title: "Securely receive funds",
                    desc: "Add your bank information, or invite your fundraiser\n                      beneficiary to add theirs, and start receiving funds.",
                  },
                ].map((step, idx, arr) => (
                  <ul key={`how-${step.num}-${idx}`}>
                    <li
                      className={`how-step ${
                        howIndex === idx ? "is-active" : ""
                      }`}
                      onClick={() => {
                        setHowIndex(idx);
                        setHowProgress(0);
                        howProgressRef.current = 0;
                        setHowPaused(true);
                        requestAnimationFrame(() => setHowPaused(false));
                      }}
                    >
                      <span className="how-step__num">{step.num}</span>
                      <div className="how-step__body">
                        <h3 className="how-step__title">{step.title}</h3>
                        <p className="how-step__desc">{step.desc}</p>
                      </div>
                    </li>
                    {idx < arr.length - 1 && null}
                  </ul>
                ))}
              </ol>
            </div>
          </section>

          <Donations />
          <Topics />

          {/* 5 */}
          <section className="trust-section" aria-labelledby="trust-heading">
            <div className="trust-section__inner">
              <p className="trust-kicker">We've got you covered.</p>
              <h2 id="trust-heading" className="trust-title">
                HeartLink is a trusted leader in online fundraising. With simple
                pricing and a team of Trust &amp; Safety experts in your corner,
                you can raise money or make a donation with peace of mind.
              </h2>
            </div>
          </section>

          {/* 6 */}
          <section className="tips-section" aria-labelledby="tips-heading">
            <div className="tips-section__inner">
              <div className="tips-section__header">
                <h2 id="tips-heading" className="tips-section__title">
                  Top crowdfunding tips
                </h2>
              </div>

              <div className="tips-list" role="list">
                {[
                  {
                    title: "Top tips for your HeartLink fundraiser",
                    icon: "/svg/light.svg",
                  },
                  {
                    title: "Tips for telling a great fundraiser story",
                    icon: "/svg/pen.svg",
                  },
                  {
                    title: "Tips for sharing your fundraiser",
                    icon: "/svg/fly.png",
                  },
                ].map((item, i) => (
                  <button
                    key={`${item.title}-${i}`}
                    type="button"
                    className="tips-card"
                    role="listitem"
                  >
                    <span className="tips-card__icon" aria-hidden="true">
                      <img src={item.icon} alt="" />
                    </span>
                    <div className="tips-card__body">
                      <h3 className="tips-card__title">{item.title}</h3>
                    </div>
                  </button>
                ))}
              </div>

              <p className="tips-note">
                *Statistics on this page are averaged figures based on 2023–2024
                HeartLink data.
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Main;
